// extracted by mini-css-extract-plugin
module.exports = {"h100":"PositionsTable_h100_20ATT","w100":"PositionsTable_w100_3DXwt","pointer":"PositionsTable_pointer_2hkUO"};